/* eslint-disable @typescript-eslint/no-empty-function */
import { getFileTypeFilterConfig, FilterConfig } from '../../types/header-toolbar.type';
import { SharedWithMeHeaderToolbarProps } from '../../utils/file-manager';
import { BaseHeaderToolbar } from '../header-toolbar/base-header-toolbar';

export const SharedWithMeHeaderToolbar: React.FC<SharedWithMeHeaderToolbarProps> = (props) => {

  const filterConfigs: FilterConfig[] = [
    getFileTypeFilterConfig(),
    {
      key: 'sharedDate',
      type: 'dateRange',
      label: 'SHARED_DATE',
    },
  ];

  return (
    <BaseHeaderToolbar
      title="SHARED_WITH_ME"
      viewMode={props.viewMode ?? 'grid'}
      searchQuery={props.searchQuery ?? ''}
      filters={props.filters}
      filterConfigs={filterConfigs}
      showFileUpload={false}
      showFolderCreate={false}
      onViewModeChange={props.handleViewMode}
      onSearchChange={props.onSearchChange ?? (() => { })}
      onFiltersChange={props.onFiltersChange}
      onFileUpload={props.onFileUpload}
      onFolderCreate={props.onFolderCreate}
      showTitle={props.showTitle}
    />
  );
};
